<!-- prettier-ignore -->

<form [formGroup]="sendChat"
class="chat__send-chat-form"
[ngClass]="{'chat__send-chat-form--show': dataChat.toggleFormVisibility()}"
(submit)="saveChat(sendChat.value)"
>
  <h2 class="chat__send-chat-heading">{{'Guardar Chat' | translate}}</h2>

  @if(inputLeads?.[0]){
    <div class="chat__send-chat-group">
      <label class="chat__send-chat-label" for="name">{{'Nombre' | translate}}</label>
      <input class="chat__send-chat-input" formControlName="name" type="text" id="name">
    </div>
  }

  <div class="chat__send-chat-group">
    <label class="chat__send-chat-label" for="">Email</label>
    <input class="chat__send-chat-input" formControlName="email" type="email" id="email">
  </div>

  @if(!dataChat.isSendingChat()){
    <button class="chat__send-chat-btn" type="submit">{{'Enviar Chat' | translate}}</button>
  }
  @else{
    <div class="chat__send-chat-loader" style="height: 27.78px;">
      <span class="loader"></span>
    </div>
  }
</form>
<!-- Mensaje éxito envio chat -->
<div
class="chat__send-chat-message"
[ngClass]="{'chat__send-chat-message--show': dataChat.toggleSuccessMessage()}"
>
  {{'Chat enviado correctamente' | translate}}
</div>
<!-- Mensaje fallo envio chat -->
<div
class="chat__send-chat-message chat__send-chat-message--error"
[ngClass]="{'chat__send-chat-message--show': dataChat.toggleErrorMessage() }"
>
  {{'Ha habido un error, vuelve a intentarlo más tarde' | translate}}
</div>
